import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { ReactComponent as FilterIcon } from '../../../assets/PepWise2.0/Filter - Icon - New.svg';
import AdvancedFilterDrawer from './AdvancedFilterDrawer';
import { AdvancedFilterDrawerProps } from './types';

type Props = AdvancedFilterDrawerProps & {
  disabled?: boolean;
  icon?: React.ReactNode;
};

export default function AdvancedFilterPanel({
  open,
  onClose,
  onApply,
  onSaveDefault,
  onResetDefault,
  currentFilters,
  filterOptions,
  filterRelationshipRecords,
  lockedStatus,
  defaultStatus,
  disabled = false,
  icon,
}: Props) {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(open);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <IconButton
          onClick={() => setIsFilterDrawerOpen(true)}
          disabled={disabled}
          sx={{ position: 'relative', p: '0px !important' }}
        >
          {icon ?? <FilterIcon />}
        </IconButton>
      </Box>

      <AdvancedFilterDrawer
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        onApply={onApply}
        onSaveDefault={onSaveDefault}
        onResetDefault={onResetDefault}
        currentFilters={currentFilters}
        filterOptions={filterOptions}
        filterRelationshipRecords={filterRelationshipRecords}
        lockedStatus={lockedStatus}
        defaultStatus={defaultStatus}
      />
    </Box>
  );
}